import React from "react";

/**
 * Bloque 3 Partner Points — bloque condicional de documento:
 * "AUTHORIZED PARTNER POINT / PUNTO DE VENTA AUTORIZADO".
 * Se renderiza SOLO cuando el doc lleva snapshot `partner_point`
 * (ventas directas de Rawen's quedan intactas).
 */
export const PartnerPointBlock = ({ pp, compact = false }) => {
  if (!pp || !(pp.business_name || "").trim()) return null;
  const csz = [pp.city, [pp.state, pp.zip].filter(Boolean).join(" ")]
    .filter(Boolean)
    .join(", ");
  return (
    <div
      data-testid="partner-point-block"
      className={`border border-black ${compact ? "p-3" : "p-4"} bg-white relative`}
    >
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-[var(--primary,black)]" />
      <div className="font-mono text-[9px] tracking-[0.18em] uppercase text-neutral-500 mb-1 pl-2">
        Authorized Partner Point / Punto de Venta Autorizado
      </div>
      <div
        data-testid="partner-point-issuer"
        className="text-[10px] italic text-neutral-500 mb-1.5 pl-2"
      >
        Emitido por / Issued by: Rawen's Printing &amp; Designs — facturación,
        cobros y producción
      </div>
      <div className="pl-2">
        <div data-testid="partner-point-name" className="font-bold text-sm">
          {pp.business_name}
        </div>
        {(pp.address || csz) && (
          <div className="text-xs text-neutral-600">
            {[pp.address, csz].filter(Boolean).join(" · ")}
          </div>
        )}
        {(pp.phone || pp.contact_name) && (
          <div className="text-xs text-neutral-600">
            {[pp.phone && `Tel: ${pp.phone}`, pp.contact_name && `Resp.: ${pp.contact_name}`]
              .filter(Boolean)
              .join(" · ")}
          </div>
        )}
        {pp.partner_code && (
          <div className="text-xs text-neutral-600">Partner ID: {pp.partner_code}</div>
        )}
        {pp.pickup_address && (
          <div className="text-xs text-neutral-600">
            Recogida / Pickup: {pp.pickup_address}
          </div>
        )}
      </div>
    </div>
  );
};
